import React, { useEffect, useMemo, useState, useRef } from 'react'
import { TbPercentage } from "react-icons/tb";
import { BsCurrencyDollar } from "react-icons/bs";
import { LiaRupeeSignSolid } from "react-icons/lia";
import './AgreementPricing.css'
import axios from 'axios';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { MdModeEdit } from "react-icons/md";
import { Box, Modal, TextField, Button, Switch } from '@mui/material';
import { checkAcessLevel,getDocumentYaakeUsers } from "../../permission";
import Popper from '@mui/material/Popper';
import AlertDialog from './AlertDialog';
import Alerts from '../Radiologists/Alerts';
import CustomAlertDialog from '../../Utils/CustomAlertDialog';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import Loader from '../../Utils/Loader';
import { Response } from '../Radiologists/Radiologists';



const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[5],
        fontSize: 11,
    },
}));


function AgreementPricing({ modality, radioValue, clientid, email, clientEmail, clientname, user, uniqueId,hospitalData,handleAccess,setAuthPop }) {
    const [pricing, setPricing] = useState({})
    const [editValue, setEditValue] = useState(null)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = useState('')
    const [selectedFile, setSelectedFile] = useState(null)
    const [confirm, setConfirm] = useState('')
    const [detail, setDetails] = useState({})
    const [defaultPricing, setDefaultPricing] = useState({})
    const [edit, setEdit] = useState(true)
    const [defaultDetail, setDefaultDetail] = useState({})
    const [confirmPop, setCOnfirmPop] = useState(false)
    const [alert, setAlert] = useState('')
    const [warning, setWarning] = useState('')
    const [otherDefaultDetails, setOtherDefaultDetails] = useState({})
    const [approve, setApprove] = useState('')
    const [attachment, setAttachment] = useState('')
    const [selectedDocs, setSelectedDocs] = useState([]);
    const [isapproved,setIsApproved]=useState(false)
    const [loader,setLoader]=useState()
    const [yaakeUser,setYaakeUser]=useState()
    const [source,setSource]=useState(null)
    const [type,setType]=useState('')
    const [comboPricing, setComboPricing] = useState([])
    const [defaultComboPricing, setDefaultComboPricing] = useState([])
    // volume based pricing: one entry per category, each carrying its own slabs
    const [pricingSlabs, setPricingSlabs] = useState([])
    const [defaultPricingSlabs, setDefaultPricingSlabs] = useState([])
    // 'amount' means the nighthawk figure is rupees, not a percentage
    const [nightHawkType, setNightHawkType] = useState('')
    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const [docData,setDocData]=useState()

    //   const open = Boolean(anchorEl);
    //   const id = open ? 'simple-popper' : undefined;

    const handleGetAgreementPrice = async () => {
        try {
            const { REACT_APP_GET_AGREEMENT_API,REACT_APP_BACKEND_API } = process.env
            const res = await axios.get(REACT_APP_BACKEND_API+'api/fetch_agreement_price' + `?client_fk=${clientid}`)
            if (res?.data?.data) {
                // Add edited_price field to each category (initialize with default price)
                const dataWithEditedPrice = {}
                Object.keys(res?.data?.data).forEach(modality => {
                    dataWithEditedPrice[modality] = res?.data?.data[modality]?.map(category => ({
                        ...category,
                        edited_price: category.price,
                        price: category.default_price
                    }))
                })
                setPricing(dataWithEditedPrice)
                setDefaultPricing(dataWithEditedPrice)
            }
            
            // Handle combo studies
            if (res?.data?.combo_agreement_study && Array.isArray(res?.data?.combo_agreement_study)) {
                const comboData = res?.data?.combo_agreement_study.map(combo => ({
                    ...combo,
                    edited_price: combo.edited_price,
                    default_price: combo.price
                }))
                setComboPricing(comboData)
                setDefaultComboPricing(comboData)
            }
            
            if (Array.isArray(res?.data?.pricing_slabs)) {
                setPricingSlabs(res.data.pricing_slabs)
                setDefaultPricingSlabs(JSON.parse(JSON.stringify(res.data.pricing_slabs)))
            } else {
                setPricingSlabs([])
                setDefaultPricingSlabs([])
            }
            setNightHawkType((res?.data?.night_hawk_type ?? '').toString().trim().toLowerCase())

            const other_details = res?.data?.['other details']?.[0]
            setDetails(other_details)
            setDefaultDetail(other_details)
            setOtherDefaultDetails(res?.data?.['other details default']?.[0])
            setSource(res?.data?.source_name)
            if(res?.data?.status==='approved'){
                setIsApproved(true)
            }
            setType(res?.data?.type)
        } catch (err) {
            console.log(err)
        }
    }
    useEffect(() => {
        handleGetAgreementPrice()
    }, [])

    // useEffect(() => {
    //          getDocumentYaakeUsers().then(data => {
    //             const user=data['yaake-users']?.map(data=>{
    //                 return data
    //             })
    //             setYaakeUser(user)
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching data:', error);
    //             });

    // }, [email])

    useEffect(() => {

        const handleGetYaakeUser = async () => {
            try {
                const { REACT_APP_GET_YAKE_USER_API } = process.env
                const res = await axios.get(REACT_APP_GET_YAKE_USER_API)
                setYaakeUser(res?.data?.data)
                // console.log(res?.data?.data)
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
       
        handleGetYaakeUser()
    }, [email])


    useEffect(() => {
        apiCall()
      }, [])

      const apiCall = async () => {
            try {
                const { REACT_APP_CLIENT_DOCUMENT_URL } = process.env
                const res = await axios.get(REACT_APP_CLIENT_DOCUMENT_URL + `${clientid}`,{
                    headers: {
                        Authorization:process.env.REACT_APP_ADMIN_API_AUTH
                        }
                })
                setDocData(res.data)
            }
            catch (err) {
                 console.log(err)
            }
      }


    const handleChangeValue = (name, value) => {
        // console.log(name, value)
        setDetails(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const handleOtherDetailUpdate=async(onboard)=>{
        const body={
            "client_id": clientid,
            "msme_registered": detail?.msme ? 'YES' :'NO',
            "pan":detail?.pan,
            "tan_number":detail?.tan,
            "gstin_number":detail?.gstin
        }
        try{
        const { REACT_APP_CLIENT_EDIT_PAYMENT_URL,REACT_APP_ADMIN_API_AUTH } = process.env
        const res = await axios.put(REACT_APP_CLIENT_EDIT_PAYMENT_URL,
          body,
          {
            headers: {
              Authorization:REACT_APP_ADMIN_API_AUTH
            }
          }
        )
        if(res?.status===200){
            handleApproveMail()
        }else{
            setLoader(false)
            setWarning('Approving Failed')
        }
        }catch(err){
            setLoader(false)
            setWarning('Approving Failed')
        }
    }

    /* ── volume based pricing ──
     * pricing_slabs arrives as one entry per (modality, category) carrying that
     * category's slabs. Slab 0 is the agreed price already shown as Final Price,
     * so only slab 1 upwards need columns of their own. The volume bands differ
     * per modality — XRAY, CT & MRI and NM each have their own — which is why the
     * ranges are listed per modality rather than in the shared header.
     */
    const isNightHawkAmount = nightHawkType === 'amount'
    const nightHawkLabel = isNightHawkAmount ? 'NightHawk Amount' : 'NightHawk Percentage'

    const slabsByGroup = useMemo(() => {
        const m = new Map()
        pricingSlabs?.forEach(entry => {
            const key = String(entry?.group_mod_id)
            if (!key) return
            m.set(key, Array.isArray(entry?.slabs) ? entry.slabs : [])
        })
        return m
    }, [pricingSlabs])

    const slabBandsByModality = useMemo(() => {
        const m = new Map()
        pricingSlabs?.forEach(entry => {
            const mod = (entry?.modality ?? '').toString().trim().toUpperCase()
            if (!mod || m.has(mod)) return
            const bands = (entry?.slabs || [])
                .slice()
                .sort((a, b) => (a?.slab_index ?? 0) - (b?.slab_index ?? 0))
                .map(sl => ({
                    slab_index: sl?.slab_index ?? 0,
                    volume_start: sl?.volume_start,
                    volume_end: sl?.volume_end,
                    discount: sl?.discount,
                }))
            if (bands.length) m.set(mod, bands)
        })
        return m
    }, [pricingSlabs])

    /**
     * Legend rows. CT and MRI always carry the same bands, so they are announced
     * once as "CT & MRI" rather than as two identical lines; XRAY and NM stand on
     * their own.
     */
    const slabLegend = useMemo(() => {
        const rows = []
        const seen = new Set()
        const bandsOf = (mod) => slabBandsByModality.get(mod)
        const ct = bandsOf('CT')
        const mri = bandsOf('MRI')
        if (ct || mri) {
            rows.push({ label: ct && mri ? 'CT & MRI' : ct ? 'CT' : 'MRI', bands: ct || mri })
            seen.add('CT')
            seen.add('MRI')
        }
        ;['XRAY', 'NM'].forEach(mod => {
            const b = bandsOf(mod)
            if (b) {
                rows.push({ label: mod, bands: b })
                seen.add(mod)
            }
        })
        // anything the feed sends that is not one of the four
        slabBandsByModality.forEach((bands, mod) => {
            if (!seen.has(mod)) rows.push({ label: mod, bands })
        })
        // XRAY first, then CT & MRI, then NM — the order the table itself uses
        const order = { XRAY: 0, 'CT & MRI': 1, CT: 1, MRI: 1, NM: 2 }
        return rows.sort((a, b) => (order[a.label] ?? 9) - (order[b.label] ?? 9))
    }, [slabBandsByModality])

    // how many columns beyond Final Price (Slab 0) the table needs
    const extraSlabCount = useMemo(() => {
        let max = 0
        pricingSlabs?.forEach(entry => {
            (entry?.slabs || []).forEach(sl => {
                max = Math.max(max, (sl?.slab_index ?? 0))
            })
        })
        return max
    }, [pricingSlabs])

    const slabPrice = (groupModId, slabIndex) => {
        const slabs = slabsByGroup.get(String(groupModId))
        if (!slabs) return null
        const hit = slabs.find(sl => (sl?.slab_index ?? 0) === slabIndex)
        return hit ? hit : null
    }

    const bandLabel = (band) => {
        const a = band?.volume_start
        const b = band?.volume_end
        if (a === undefined || a === null) return ''
        return b === undefined || b === null ? `${a}+` : `${a}–${b}`
    }

    /**
     * The Final Price cell.
     *
     * When a category has volume slabs, slab 0 carries its OWN price — the agreed
     * price less that slab's discount (250 agreed, 237 at slab 0) — so this column
     * must show the slab, not `edited_price`. Without slabs it is the agreed price
     * as before. Red marks a departure from the default in either case.
     */
    const renderFinalPriceCell = (modality, data) => {
        const slabZero = slabPrice(data?.group_mod_id, 0)
        const value = slabZero ? slabZero?.price : data?.edited_price
        const changed = parseInt(value) !== parseInt(data?.price)
        const colour = changed ? 'red' : 'black'
        const band = (slabBandsByModality.get((modality || '').toUpperCase()) || []).find(b => b.slab_index === 0)
        return (
            <td title={slabZero ? `${modality} · Slab 0${band ? ` · volume ${bandLabel(band)}` : ''}${slabZero?.discount ? ` · ${slabZero.discount}% off` : ''}` : undefined}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex' }}>
                        <div>{radioValue === 'Dollar' ?
                            <BsCurrencyDollar style={{ color: colour }} /> :
                            <LiaRupeeSignSolid style={{ color: colour }} />
                        }</div>
                        <div><span style={{ color: colour }}>{value}</span></div>
                    </div>
                    <div>
                        <MdModeEdit className='edit-icon' onClick={() => {
                            if (isapproved) {
                                return
                            }
                            setOpen({
                                id: data?.group_mod_id,
                                price: value,
                                type: modality,
                                // editing this cell edits slab 0 when there is one
                                ...(slabZero ? { slabIndex: 0 } : {})
                            })
                        }} />
                    </div>
                </div>
            </td>
        )
    }

    /** The slab cells for one category row: slab 1 upwards, each editable. */
    const renderSlabCells = (modality, data) => {
        if (extraSlabCount <= 0) return null
        const bands = slabBandsByModality.get((modality || '').toUpperCase()) || []
        return Array.from({ length: extraSlabCount }, (_, i) => {
            const index = i + 1
            const slab = slabPrice(data?.group_mod_id, index)
            const band = bands.find(b => b.slab_index === index)
            // a modality with fewer slabs than the widest one leaves a blank cell,
            // rather than borrowing another modality's band
            if (!slab) {
                return <td key={`slab-${modality}-${index}`}><span style={{ color: '#bbb' }}>—</span></td>
            }
            return (
                <td key={`slab-${modality}-${index}`} title={`${modality} · Slab ${index}${band ? ` · volume ${bandLabel(band)}` : ''}`}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex' }}>
                            <div>{radioValue === 'Dollar' ? <BsCurrencyDollar /> : <LiaRupeeSignSolid />}</div>
                            <div><span>{slab?.price}</span></div>
                        </div>
                        <div>
                            <MdModeEdit className='edit-icon' onClick={() => {
                                if (isapproved) {
                                    return
                                }
                                setOpen({
                                    id: data?.group_mod_id,
                                    price: slab?.price,
                                    type: modality,
                                    slabIndex: index
                                })
                            }} />
                        </div>
                    </div>
                </td>
            )
        })
    }

    const handleEditSlab = (groupModId, slabIndex, value) => {
        setAnchorEl(null)
        setPricingSlabs(prev => prev?.map(entry => {
            if (String(entry?.group_mod_id) !== String(groupModId)) return entry
            return {
                ...entry,
                slabs: (entry?.slabs || []).map(sl =>
                    (sl?.slab_index ?? 0) === slabIndex ? { ...sl, price: parseInt(value) } : sl
                ),
            }
        }))
        setEditValue('')
    }

    const handleEditValue = (modality, id, value, slabIndex) => {
        // a slab cell edits its own slab, not the agreed price
        if (slabIndex !== undefined && slabIndex !== null) {
            handleEditSlab(id, slabIndex, value)
            return
        }
        setAnchorEl(null)
        
        setPricing((prev) => {
            return {
                ...prev,
                [modality]: prev?.[modality]?.map(data => {
                    if (id === parseInt(data?.group_mod_id)) {
                        return { ...data, edited_price: parseInt(value) }
                    } else {
                        return { ...data }
                    }
                })
            }
        })

        setEditValue('')
    }

    const handleUploadToProduction = async () => {
        try {
            // handleApproveMail()
            // return 
            setApprove(false)
            setLoader('uploading')
            const { REACT_APP_PRICE_UPLOAD_PRODUCTION_API,REACT_APP_BACKEND_API } = process.env

            /* Volume pricing travels as ONE column holding the whole array, rather
             * than a column per slab — the number of slabs differs by modality, so
             * a fixed set of columns cannot carry it. Both keys are omitted when the
             * agreement has nothing of that kind, so existing clients upload exactly
             * as they did before. */
            const productionBody = {}
            if (nightHawkType) {
                productionBody.night_hawk_type = nightHawkType
            }
            if (pricingSlabs?.length) {
                productionBody.volume_based_pricing = pricingSlabs.map(entry => ({
                    group_mod_id: entry?.group_mod_id,
                    modality: entry?.modality,
                    category: entry?.category,
                    slabs: (entry?.slabs || [])
                        .slice()
                        .sort((a, b) => (a?.slab_index ?? 0) - (b?.slab_index ?? 0))
                        .map(sl => ({
                            slab_index: sl?.slab_index,
                            volume_start: sl?.volume_start,
                            volume_end: sl?.volume_end,
                            discount: sl?.discount,
                            price: sl?.price,
                        })),
                }))
            }

            const res = await axios.post(
                REACT_APP_BACKEND_API + 'api/upload_price_to_production_new/' + `?client_fk=${clientid}&client_email=${clientEmail}&user_by=${email}`,
                productionBody
            )
            // console.log(res)
            if (res?.data == "Price updated successfully") {
                handleOtherDetailUpdate()
                handleApproveMail()
            }else{
                setLoader(false)
                setWarning('Price Updation Failed')
            }
        } catch (err) {
            setLoader(false)
            setWarning('Price Updation Failed')
        }
    }

    const handleApproveMail = async () => {
        try {

            const formData = new FormData();
            formData.append("file", selectedFile);
            const clientSource = source?.split(' and ')
            console.log(clientSource)
            const sourceEmail = yaakeUser?.filter(data=>{
                if(clientSource?.includes(data?.name)){
                    return data
                }
            })?.map(data=>data?.email)
            // console.log(sourceEmail?.join(','))
            // const source='nikhil@5cnetwork.com'
            // const sender = 'Bhavya S'

            const { REACT_APP_PRICE_FINANCE_APPROVE_MAIL_URL,REACT_APP_BACKEND_API } = process.env
            const response = await axios.post(
                REACT_APP_BACKEND_API + `api/finance_approving_mail_new/?client_fk=${clientid}&client_name=${clientname}&sender=${user?.name}&unique_id=${uniqueId}&client_source=${sourceEmail?.join(',')}&type=${type}`,
                formData
            );

            if (response?.status >= 200 && response?.status < 300) {
                setLoader('Pricing Approved Successfully')
                handleGetAgreementPrice()
            } else {
                setWarning('Approving Failed')
            }
        } catch (err) {
            setWarning('Approving Failed')
            setLoader(false)
            console.log(err)
        }
    }


    const handleEditDetails = async () => {
        try {
            const { REACT_APP_EDIT_AGREEMENT_OTHER_DETAILS_API } = process.env
            const body = {
                night_hawk_price: detail?.night_hawk_price ? detail?.night_hawk_price : '',
                holiday_price: detail?.holiday_price ? detail?.holiday_price : '',
                pan: detail?.pan ? detail?.pan : '',
                tan: detail?.tan ? detail?.tan : '',
                msme: detail?.msme ? detail?.msme : '',
                gstin: detail?.gstin ? detail?.gstin : '',
                ct_tat: detail?.ct_tat ? detail?.ct_tat : '',
                xray_tat: detail?.xray_tat ? detail?.xray_tat : '',
                nm_tat: detail?.nm_tat ? detail?.nm_tat : '',
                mri_tat: detail?.mri_tat ? detail?.mri_tat : '',
                currency_type: detail?.currency_type ? detail?.currency_type : '',
                additional_view_price: detail?.additional_view_price ? detail?.additional_view_price : 0,
                is_additional_view_price: detail?.is_additional_view_price ? detail?.is_additional_view_price : '',
                off_hours: detail?.off_hours ? detail?.off_hours : '',
                discount: detail?.discount ? detail?.discount : 0,
                registration_number: detail?.registration_number ? detail?.registration_number : '',
                currency_type: detail?.currency_type ? detail?.currency_type : '',
                client_fk: detail?.client_fk ? detail?.client_fk : ''
            }
            const res = await axios.post(REACT_APP_EDIT_AGREEMENT_OTHER_DETAILS_API, body)
            if (res?.status === 200) {
                setAlert('Updated Successfully')
            } else {
                setWarning('Updation Failed')
            }
            // console.log(res)
        } catch (err) {
            setWarning('Updation Failed')
        } finally {
            // handleGetAgreementPrice()
            setCOnfirmPop(false)
        }
    }

    const handleEditApi = async () => {
        try {
            const { REACT_APP_EDIT_AGREEMENT_API, REACT_APP_BACKEND_API } = process.env
            let price = []
            
            // Collect only CHANGED prices from all modalities
            Object.keys(pricing).forEach(modality => {
                pricing[modality]?.forEach(data => {
                    // Only include if price has been changed
                    if (data?.edited_price !== data?.price) {
                        const mod_study_fks = data?.organs?.map(organ => 
                            parseInt(organ?.mod_study_fk)
                        ).filter(fk => !isNaN(fk));
                        
                        price.push({
                            group_mod_id: data?.group_mod_id,
                            mod_study_fks: mod_study_fks,
                            modality: modality,
                            price: data?.edited_price
                        })
                    }
                })
            })
            
            // Collect changed combo prices
            let combo_price = []
            comboPricing?.forEach((combo, index) => {
                // Only include if combo price has been changed
                if (combo?.edited_price !== combo?.default_price) {
                    combo_price.push({
                        mod_study_fks: combo?.mod_study_fks || [],
                        mod_study_names: combo?.mod_study_names || [],
                        name: combo?.name || '',
                        price: combo?.edited_price
                    })
                }
            })
            
            // Collect changed slab prices, matched against what the feed sent
            let pricing_slabs = []
            pricingSlabs?.forEach(entry => {
                const original = defaultPricingSlabs?.find(
                    d => String(d?.group_mod_id) === String(entry?.group_mod_id)
                )
                const changed = (entry?.slabs || []).filter(sl => {
                    const was = (original?.slabs || []).find(o => (o?.slab_index ?? 0) === (sl?.slab_index ?? 0))
                    return was && parseInt(was.price) !== parseInt(sl.price)
                })
                if (changed.length) {
                    pricing_slabs.push({
                        group_mod_id: entry?.group_mod_id,
                        modality: entry?.modality,
                        category: entry?.category,
                        slabs: changed,
                    })
                }
            })

            // Check if there are any changes
            if (price.length === 0 && combo_price.length === 0 && pricing_slabs.length === 0) {
                setWarning('No changes to update')
                return
            }
            
            const data = {
                client_fk: clientid,
                user_by: email,
                price: price,
                combo_price: combo_price,
                // only sent when a slab price was actually changed, so the field is
                // absent on agreements that have no volume pricing
                ...(pricing_slabs.length ? { pricing_slabs } : {})
            }
            
            const res = await axios.post(REACT_APP_BACKEND_API+'api/agreement_price_edit_new/', data)
            
            if (res?.data?.message === 'Data inserted successfully' || res?.status === 200) {
                setAlert('Updated Successfully')
            } else {
                setWarning('Updation Failed')
            }
        } catch (err) {
            setWarning('Updation Failed')
            console.log(err)

        } finally {
            setConfirm(false)
            handleGetAgreementPrice()
        }
    }

    // Helper function to render unique organ labels
    const renderOrganPills = (organs, categoryPrice) => {
        // Get unique organ labels
        const uniqueOrgans = [...new Set(organs?.map(organ => organ?.organ_label))];
        
        return uniqueOrgans.map((label, idx) => {
            let displayLabel = label;
            
            // Special handling for "Per View" labels
            if (label === 'Per View') {
                if (!detail?.is_additional_view_price) {
                    displayLabel = 'Per Report';
                } else if (categoryPrice !== 50) {
                    displayLabel = 'Single View';
                }
            }
            
            return (
                <span key={idx} className="organ-pill">
                    {displayLabel}
                </span>
            );
        });
    }

    const handleEditComboValue = (index, value) => {
        setComboPricing((prev) => {
            return prev.map((combo, idx) => {
                if (idx === index) {
                    return { ...combo, edited_price: parseInt(value) }
                }
                return combo
            })
        })
        setEditValue('')
    }
    return (
        <div className='agreement' style={{ display: 'flex' }}>
            <div style={{ width: '100%', marginRight: '30px' }}>
                <div>
                    {extraSlabCount > 0 && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            flexWrap: 'nowrap',
                            whiteSpace: 'nowrap',
                            overflowX: 'auto',
                            border: '1px solid #cbd5e1',
                            borderLeft: '4px solid #0059B2',
                            borderRadius: '6px',
                            padding: '6px 12px',
                            margin: '0 0 8px 0',
                            background: '#f8faff',
                        }}>
                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#0059B2', letterSpacing: '0.04em', flex: 'none' }}>
                                VOLUME SLABS
                            </span>
                            {/* one line: XRAY, then CT & MRI which always share their
                                bands, then NM — scrolls sideways rather than wrapping */}
                            {slabLegend.map(row => (
                                <React.Fragment key={row.label}>
                                    <span style={{
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        color: '#fff',
                                        background: '#0059B2',
                                        borderRadius: '4px',
                                        padding: '2px 8px',
                                        flex: 'none',
                                    }}>
                                        {row.label}
                                    </span>
                                    {row.bands.map(b => (
                                        <span key={b.slab_index} style={{
                                            fontSize: '13px',
                                            color: '#1e293b',
                                            background: '#fff',
                                            border: '1px solid #cbd5e1',
                                            borderRadius: '4px',
                                            padding: '2px 8px',
                                            flex: 'none',
                                        }}>
                                            <b>Slab {b.slab_index}</b>
                                            <span style={{ color: '#475569' }}> · {bandLabel(b)}</span>
                                            {b.discount !== undefined && b.discount !== null && Number(b.discount) !== 0 && (
                                                <span style={{ color: '#0f766e', fontWeight: 'bold' }}> · {b.discount}%</span>
                                            )}
                                        </span>
                                    ))}
                                </React.Fragment>
                            ))}
                        </div>
                    )}
                    <table border="0.5" cellspacing="0" cellpadding="8" style={{ boxShadow: '0px 0px 5px lightgrey', width: '100%' }} >
                        <tbody>
                            <tr style={{ backgroundColor: '#0059B2', color: 'white', position: 'sticky', top: '0', zIndex: '1' }}>
                                <td colSpan={5 + extraSlabCount} style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px' }}>
                                    STANDARD PRICING (8:00 AM to 7:59 PM) on Working Days (Mon-Sat)
                                </td>
                            </tr>
                            <tr style={{ position: 'sticky', top: '0', zIndex: '1', background: 'white' }}>
                                <td style={{ fontSize: '16px', fontWeight: 'bold' }}>Modality</td>
                                <td style={{ fontSize: '16px', fontWeight: 'bold' }}>Category Name</td>
                                <td style={{ fontSize: '16px', fontWeight: 'bold' }}>Select any from the following Studies</td>
                                <td style={{ fontSize: '16px', fontWeight: 'bold' }}>Default Price</td>
                                <td style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                    {extraSlabCount > 0 ? 'Final Price (Slab 0)' : 'Final Price'}
                                </td>
                                {Array.from({ length: extraSlabCount }, (_, i) => (
                                    <td key={`slab-head-${i + 1}`} style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                        Slab {i + 1}
                                    </td>
                                ))}
                            </tr>
                            {pricing?.XRAY
                                ?.sort((a, b) => a?.group_mod_id - b?.group_mod_id)?.map((data, id) => (
                                    <tr key={id}>
                                        {id === 0 && <td rowSpan={pricing?.XRAY?.length} style={{verticalAlign: 'top', paddingTop: '10px'}}>XRAY</td>}
                                        <td>{data?.category}</td>
                                        <td>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                                {renderOrganPills(data?.organs, data?.price)}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex' }}>
                                                <div>{radioValue === 'Dollar' ?
                                                    <BsCurrencyDollar /> : <LiaRupeeSignSolid />
                                                }</div>
                                                <div><span>{data?.price}</span></div>
                                            </div>
                                        </td>
                                        {renderFinalPriceCell('XRAY', data)}
                                    {renderSlabCells('XRAY', data)}
                                    </tr>
                                ))}



                            {pricing?.CT?.sort((a,b)=>a?.price-b?.price)?.map((data, id) => (
                                <tr key={id}>
                                    {id === 0 && <td rowSpan={pricing?.CT?.length} style={{verticalAlign: 'top', paddingTop: '10px'}}>CT</td>}
                                    <td>{data?.category}</td>
                                    <td>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                            {renderOrganPills(data?.organs, data?.price)}
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex' }}>
                                            <div>{radioValue === 'Dollar' ?
                                                <BsCurrencyDollar /> : <LiaRupeeSignSolid />
                                            }</div>
                                            <div><span>{data?.price}</span></div>
                                        </div>
                                    </td>
                                    {renderFinalPriceCell('CT', data)}
                                {renderSlabCells('CT', data)}
                                </tr>
                            ))}
                            {pricing?.MRI?.sort((a,b)=>a?.price-b?.price)?.map((data, id) => (
                                <tr key={id}>
                                    {id === 0 && <td rowSpan={pricing?.MRI?.length} style={{verticalAlign: 'top', paddingTop: '10px'}}>MRI</td>}
                                    <td>{data?.category}</td>
                                    <td>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                            {renderOrganPills(data?.organs, data?.price)}
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex' }}>
                                            <div>{radioValue === 'Dollar' ?
                                                <BsCurrencyDollar /> : <LiaRupeeSignSolid />
                                            }</div>
                                            <div><span>{data?.price}</span></div>
                                        </div>
                                    </td>
                                    {renderFinalPriceCell('MRI', data)}
                                {renderSlabCells('MRI', data)}
                                </tr>
                            ))}


                            {pricing?.NM?.sort((a,b)=>a?.price-b?.price)?.map((data, id) => (
                                <tr key={id}>
                                    {id === 0 && <td rowSpan={pricing?.NM?.length} style={{verticalAlign: 'top', paddingTop: '10px'}}>NM</td>}
                                    <td>{data?.category}</td>
                                    <td>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                            {renderOrganPills(data?.organs, data?.price)}
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex' }}>
                                            <div>{radioValue === 'Dollar' ?
                                                <BsCurrencyDollar /> : <LiaRupeeSignSolid />
                                            }</div>
                                            <div><span>{data?.price}</span></div>
                                        </div>
                                    </td>
                                    {renderFinalPriceCell('NM', data)}
                                {renderSlabCells('NM', data)}
                                </tr>
                            ))}


                            {/* Repeat the rest of the table rows here */}
                        </tbody>
                    </table>
                </div>
                {/* Combo Studies Table */}
                {comboPricing && comboPricing.length > 0 && (
                    <div style={{ marginTop: '12px' }}>
                        <table border="0.5" cellSpacing="0" cellPadding="8" style={{ boxShadow: '0px 0px 5px lightgrey', width: '100%' }}>
                            <tbody>
                                <tr style={{ backgroundColor: '#0059B2', color: 'white', position: 'sticky', top: '0', zIndex: '1' }}>
                                    <td colSpan={4} style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px' }}>
                                        COMBO STUDIES PRICING
                                    </td>
                                </tr>
                                <tr style={{ position: 'sticky', top: '0', zIndex: '1', background: 'white' }}>
                                    <td style={{ fontSize: '16px', fontWeight: 'bold' }}>Combo Name</td>
                                    <td style={{ fontSize: '16px', fontWeight: 'bold' }}>Studies Included</td>
                                    <td style={{ fontSize: '16px', fontWeight: 'bold' }}>Default Price</td>
                                    <td style={{ fontSize: '16px', fontWeight: 'bold' }}>Final Price</td>
                                </tr>
                                {comboPricing.map((combo, index) => (
                                    <tr key={index}>
                                        <td style={{ fontWeight: '600' }}>{combo?.name}</td>
                                        <td>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                                {combo?.mod_study_names?.map((studyName, idx) => (
                                                    <span key={idx} className="organ-pill">
                                                        {studyName}
                                                    </span>
                                                ))}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex' }}>
                                                <div>{radioValue === 'Dollar' ?
                                                    <BsCurrencyDollar /> : <LiaRupeeSignSolid />
                                                }</div>
                                                <div><span>{combo?.default_price}</span></div>
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div style={{ display: 'flex' }}>
                                                    <div>{radioValue === 'Dollar' ?
                                                        <BsCurrencyDollar style={{ color: combo.edited_price !== combo?.default_price ? 'red' : 'black' }} /> : 
                                                        <LiaRupeeSignSolid style={{ color: combo.edited_price !== combo?.default_price ? 'red' : 'black' }} />
                                                    }</div>
                                                    <div><span style={{ color: combo.edited_price !== combo?.default_price ? 'red' : 'black' }}>{combo?.edited_price}</span></div>
                                                </div>
                                                <div>
                                                    <MdModeEdit className='edit-icon' onClick={() => {
                                                        if(isapproved){
                                                            return
                                                        }
                                                        setOpen({
                                                            id: index,
                                                            price: combo?.edited_price,
                                                            type: 'COMBO'
                                                        })
                                                    }}/>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}  >
                    <div className='agreement-button' >
                        <button />
                        <button  style={{backgroundColor: isapproved&&'grey'}}
                        disabled={isapproved}
                         onClick={() => {
                            if(handleAccess('Hospital','Agreement')!==true){
                                setAuthPop(true)
                                return
                              }
                            // if(!pricing?.XRAY&& !pricing?.CT&& !pricing?.MRI && !pricing?.NM  ){
                            //     return
                            // }
                            const dataDoc = docData?.map(data=>{
                                if(data?.type==='MOU'){
                                    return data
                                }
                            })
                            // console.log(dataDoc)
                            if(dataDoc?.length){
                            setAttachment(true) 
                            // handleApproveMail()
                         }else{
                            setWarning('Please Attach the MOU before approving')
                         }
                         
                         }}>Approve</button>
                    </div>

                    <div className='agreement-button'>
                        <button disabled={isapproved} onClick={() => { 
                            setPricing(defaultPricing)
                            setComboPricing(defaultComboPricing)
                        }}>Reset</button>
                        <button disabled={isapproved} onClick={() => {
                            if(handleAccess('Hospital','Agreement')!==true){
                                setAuthPop(true)
                                return
                          }
                           if(!pricing?.XRAY&& !pricing?.CT&& !pricing?.MRI && !pricing?.NM  ){
                                return
                            }
                            setConfirm(true) }}>Update</button>
                    </div>
                </div>
            </div>

            <div style={{ width: '30%' }}>

                <div className='other-details'>

                    <div>
                        <div className='label'> {nightHawkLabel} </div>
                        {/* 25 is the standard percentage, so it only marks a
                            departure when the figure IS a percentage */}
                        <div ><input disabled={edit} style={{ color: !isNightHawkAmount && detail?.night_hawk_price !== 25 ? 'red' : 'black' }} type='number' value={detail?.night_hawk_price ? detail?.night_hawk_price : ''} onChange={(e) => {
                            handleChangeValue('night_hawk_price', e.target.value)
                        }} className='input-agreement' placeholder={nightHawkLabel} /> </div>
                    </div>
                    <div style={{ marginTop: '10px', width: '100%' }}>
                        <div className='box-shape'>
                            <div>Enable Additional View</div>
                            <div> <Switch disabled={edit} onChange={(e) => {
                                handleChangeValue('is_additional_view_price', e.target.checked)
                            }} checked={detail?.is_additional_view_price} /></div>
                        </div>
                    </div>
                    {detail?.is_additional_view_price &&
                        <div>
                            <div className='label'> Additional View Price </div>
                            <div ><input type='number' style={{ color: detail?.additional_view_price !== 50 ? 'red' : 'black' }} disabled={edit} value={detail?.additional_view_price ? detail?.additional_view_price : ''} onChange={(e) => {
                                handleChangeValue('additional_view_price', e.target.value)
                            }} className='input-agreement' placeholder='additional_view_price' /> </div>
                        </div>
                    }
                    <div>
                        <div className='label'> Holiday Percentage </div>
                        <div ><input style={{ color: detail?.holiday_price !== 25 ? 'red' : 'black' }} disabled={edit} type='number' value={detail?.holiday_price ? detail?.holiday_price : ''} onChange={(e) => {
                            handleChangeValue('holiday_price', e.target.value)
                        }} className='input-agreement' placeholder='Holiday Percentage' /> </div>
                    </div>
                    {/* <div>
                    <div className='label'> Perview Price </div>
                    <div ><input value={detail?.additional_view_price} className='input-agreement' placeholder='Perview Price'/> </div>
                </div> */}

                    <div>
                        <div className='label'> PAN </div>
                        <div ><input style={{ color: detail?.pan !== otherDefaultDetails?.pan ? 'red' : 'black' }} disabled={edit} value={detail?.pan ? detail?.pan : ''} onChange={(e) => {
                            handleChangeValue('pan', e.target.value)
                        }} className='input-agreement' placeholder='PAN' /> </div>
                    </div>

                    <div>
                        <div className='label'> TAN </div>
                        <div ><input style={{ color: detail?.tan !== otherDefaultDetails?.tan ? 'red' : 'black' }} disabled={edit} value={detail?.tan ? detail?.tan : ''} onChange={(e) => {
                            handleChangeValue('tan', e.target.value)
                        }} className='input-agreement' placeholder='TAN' /> </div>
                    </div>

                    <div>
                        <div className='label'> MSME </div>
                        <div ><input style={{ color: detail?.msme !== otherDefaultDetails?.msme ? 'red' : 'black' }} disabled={edit} value={detail?.msme ? detail?.msme : ''} onChange={(e) => {
                            handleChangeValue('msme', e.target.value)
                        }} className='input-agreement' placeholder='MSME' /> </div>
                    </div>

                    <div>
                        <div className='label'> GST </div>
                        <div ><input style={{ color: detail?.gst !== otherDefaultDetails?.gst ? 'red' : 'black' }} disabled={edit} value={detail?.gst ? detail?.gst : ''} onChange={(e) => {
                            handleChangeValue('gst', e.target.value)
                        }} className='input-agreement' placeholder='GST' /> </div>
                    </div>

                </div>

                <div className='agreement-button'>

                    <button disabled={isapproved} onClick={() => {
                        setDetails({ ...defaultDetail })
                    }} >Reset</button>
                    <button disabled={isapproved} onClick={() => {
                         if(handleAccess('Hospital','Agreement')!==true){
                            setAuthPop(true)
                            return
                        }

                        if(!pricing?.XRAY&& !pricing?.CT&& !pricing?.MRI && !pricing?.NM  ){
                            return
                        }
                        setCOnfirmPop(true) }}>Update</button>
                    <button disabled={isapproved} onClick={() => {
                        setEdit(prev => !prev)
                    }} > {edit ? 'Edit' : 'Unedit'}</button>
                </div>


            </div>



            <Alerts alert={alert} setAlert={setAlert} warning={warning} setWarning={setWarning} />



            <EditHandlePrice open={open} onClose={() => setOpen(false)} handleEditValue={handleEditValue} handleEditComboValue={handleEditComboValue} />

            <AlertDialog open={confirm} handleClose={() => setConfirm(false)} UpdateFunction={handleEditApi} />

            <AlertDialog open={confirmPop} handleClose={() => setCOnfirmPop(false)} UpdateFunction={handleEditDetails} />

            <Dialog
                open={attachment}
                // TransitionComponent={Transition}
                keepMounted
                onClose={() => setAttachment(false)}
                aria-describedby="alert-dialog-slide-description"
                maxWidth="sm"
                fullWidth
            >
                <div>
                    <DialogTitle>Attachment</DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{ display: 'flex', alignItems: 'center ' }} id="alert-dialog-slide-description">
                            <div> Please Attach the signed agreement document </div>
                            <div style={{ marginLeft: '10px' }}>
                                <label for="file-upload" class="custom-file-upload">
                                    Upload
                                </label>
                                <input
                                    className='attachment-button'
                                    type="file"
                                    // accept=".pdf"
                                    id="file-upload"
                                    multiple
                                    onChange={(el) => {
                                        setSelectedFile(el.target.files?.[0])
                                        el.target.files?.length &&
                                            setSelectedDocs(Array.from(el.target.files))
                                    }}
                                />
                            </div>
                        </DialogContentText>
                        <>
                            <DocViewer style={{ height: selectedDocs?.length > 0 ? '450px' : '0px' }}
                                documents={selectedDocs.map((file) => ({
                                    uri: window.URL.createObjectURL(file),
                                    fileName: 'MOU Document',
                                }))}
                                pluginRenderers={DocViewerRenderers}
                            />
                        </>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            setSelectedDocs([])
                            setAttachment(false)
                        }}>Cancel</Button>
                        <Button onClick={() => {
                            if (selectedDocs?.length == 0) {
                                return
                            }
                            setAttachment(false)
                            setApprove(true)
                        }}>Next</Button>
                    </DialogActions>
                </div>

            </Dialog>



            <CustomAlertDialog open={approve} UpdateFunction={handleUploadToProduction} handleClose={() => {
                setAttachment(false)
                setApprove(false)
            }}  >
                <p>
                    Are you sure you want to approve the pricing
                </p>
                <p>
                    Once you click the approve the pricing info will be moved to production
                </p>
            </CustomAlertDialog>


            <Loader open={loader=='uploading'&&true}  handleClose={() => {
                   setAttachment(false)
                   setLoader(false)
            }}  >
                <div style={{fontWeight:'600'}}> Price Updating....</div>
               
            </Loader>


            <Response data={(loader && loader!=='uploading') && loader} setData={setLoader} />

        </div>
    )
}

export default AgreementPricing


const EditHandlePrice = ({ open, onClose, handleEditValue, handleEditComboValue }) => {
    const erroRef = useRef()
    const [inputValue, setValue] = useState()

    // console.log(value)
    const handleSubmit = () => {
        if (open?.type === 'COMBO') {
            handleEditComboValue(open?.id, inputValue)
        } else {
            handleEditValue(open?.type, open?.id, inputValue, open?.slabIndex)
        }
        onClose()
    }

    useEffect(() => {

        setValue(open?.price)

    }, [open])


    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '1px solid lightblue',
        boxShadow: 24,
        p: 4,
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
        >

            <Box sx={{ ...style }}>

                <div className='pop-edit'>
                    <div className='text-red-500' style={{ textAlign: 'center', fontSize: '23px', marginBottom: '30px', color: 'darkblue' }}>Edit Agreement Price</div>
                    <div style={{ textAlign: 'center', marginBottom: '30px' }}>

                        <TextField className='edit-label' value={inputValue} onChange={(event) => {
                            setValue(event.target.value)
                            erroRef.current.innerHTML = ''
                        }} id="outlined-basic" label={'Price'} variant="outlined" />

                    </div>
                    <div style={{ textAlign: 'center', color: 'red' }} ref={erroRef}></div>
                    <div style={{ textAlign: 'center', marginBottom: '5px', marginTop: '30px', }}>
                        <Button sx={{ marginRight: '30px', fontSize: '13px' }} onClick={() => {
                            setValue('')
                            onClose()
                        }} variant="contained">Close</Button>
                        <Button sx={{ fontSize: '13px' }} onClick={() => {
                            if (inputValue === null || inputValue === '') {
                                return
                            }
                            handleSubmit()
                        }} variant="contained">Save</Button>
                    </div>
                </div>

            </Box>
        </Modal>
    )
}
